export const GET_NFTS_REQUEST = 'GET_NFTS_REQUEST';
export const GET_NFTS_DATA = 'GET_NFTS_DATA';
export const GET_NFTS_ERROR = 'GET_NFTS_ERROR';

export const CREATE_NFT_REQUEST = 'CREATE_NFT_REQUEST';
export const CREATE_NFT_DATA = 'CREATE_NFT_DATA';
export const CREATE_NFT_ERROR = 'CREATE_NFT_ERROR';

export const UPDATE_NFT_REQUEST = 'UPDATE_NFT_REQUEST';
export const UPDATE_NFT_DATA = 'UPDATE_NFT_DATA';
export const UPDATE_NFT_ERROR = 'UPDATE_NFT_ERROR';

export const DELETE_NFT_REQUEST = 'DELETE_NFT_REQUEST';
export const DELETE_NFT_DATA = 'DELETE_NFT_DATA';
export const DELETE_NFT_ERROR = 'DELETE_NFT_ERROR';

export const UPDATE_QUICK_FILTER = 'UPDATE_NFT_QUICK_FILTER';
export const FILTER_NFTS = 'FILTER_NFTS';
export const SET_NFTS_SORT_DATA = 'SET_NFTS_SORT_DATA';
export const SORT_NFTS = 'SORT_NFTS';
